"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaffleReleaseButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const styled_1 = require("@framework/styled");
const types_1 = require("@framework/types");
const releaseFunds_json_1 = __importDefault(require("@framework/abis/json/LotteryRandom/releaseFunds.json"));
const hooks_1 = require("../../../../../hooks");
const RaffleReleaseButton = (props) => {
    const { className, disabled, round, onRefreshPage = () => {
        return;
    }, variant, } = props;
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { hasPermission } = (0, hooks_1.useSetButtonPermission)(types_1.AccessControlRoleType.DEFAULT_ADMIN_ROLE, round.contract?.id);
    const { execute: metaFn } = (0, react_hooks_eth_1.useMetamask)(async () => {
        return writeContractAsync({
            address: round.contract.address,
            abi: releaseFunds_json_1.default,
            functionName: "releaseFunds",
            args: [round.roundId],
        });
    });
    const handleRelease = () => {
        return () => {
            return metaFn().then(onRefreshPage);
        };
    };
    const timeAfterRound = Math.ceil((new Date().getTime() - new Date(round.endTimestamp).getTime()) / 1000);
    const release = timeAfterRound >= Number(round.contract.parameters.timeLagBeforeRelease);
    return ((0, jsx_runtime_1.jsx)(styled_1.ListAction, { onClick: handleRelease(), icon: icons_material_1.Redeem, message: "form.tips.release", className: className, dataTestId: "RaffleReleaseButton", disabled: disabled || !round.endTimestamp || !release || !hasPermission, variant: variant }));
};
exports.RaffleReleaseButton = RaffleReleaseButton;
//# sourceMappingURL=index.js.map